<script setup lang="ts">

type Props = {
    panel: number,
    currentPanel: number,
    currentCategory: number
}

defineProps<Props>();

</script>

<template>

    <div class="p-8 flex flex-col gap-4 items-center justify-center">

        <h2 class="text-2xl text-white font-semibold mb-4">
            How Does It Work?
        </h2>

        <video 
            v-if="panel == currentPanel"
            ref="video"
            width="100%" 
            autoplay 
            controls 
            class="w-[84%] max-h-[58vh] rounded-2xl shadow-xl shadow-white/20 ring-[3px] ring-white bg-white"
            onloadstart="this.volume=0.3">
            <source src="@/assets/video/protect.mp4" type="video/mp4" />
        </video> 
        
        <h2 class="absolute text-2xl text-indigo-300 font-semibold mb-4 bottom-[4.5rem] 3xl:bottom-32">
            Let's see what's included
        </h2>

    </div>

</template>